import React from 'react';
import { EditPage } from '../edit_page/EditPage';
import AssetCycleRunForm from '../AssetCycleRunForm';
import { connect } from 'react-redux';
import { withUserType } from '../withUserType';

function NewAssetCycleEventPage({ history, fetching, userType }) {
	return (
		<EditPage
			title="Create Asset Count Event"
			formComponentProps={{
				formData: {},
				isEditForm: false,
				onSuccess: (rec) => history.push(`/${userType}/assetcycleevents/detail/${rec.id}/details`),
			}}
			// fetching={fetching}
			FormComponent={AssetCycleRunForm}
		/>
	);
}

const mapStateToProps = (state) => ({
	// fetching: state.cycle_events.fetching,
});

export default withUserType(connect(mapStateToProps)(NewAssetCycleEventPage as any));
